import { Link, NavLink, Outlet, useParams } from 'react-router-dom';

import { Spinner } from '../../components/ui';
import { MemberAuthProvider, useMemberAuth } from '../../context/MemberAuthContext';

function Inner() {
  const { me, loading, logout } = useMemberAuth();
  const { slug } = useParams<{ slug: string }>();

  if (loading) return <Spinner />;
  if (!me) return <RedirectToSignIn slug={slug ?? ''} />;

  return (
    <div className="min-h-screen bg-cream-100">
      <header
        className="text-cream-100 px-6 py-4 flex items-center justify-between"
        style={{ background: me.org.primaryColor ?? '#0F1E3C' }}
      >
        <Link to={`/m/${slug}`} className="font-display italic text-xl">
          {me.org.name}
        </Link>
        <div className="flex items-center gap-4 text-sm">
          <NavLink to={`/m/${slug}`} end className={({ isActive }) => (isActive ? 'underline' : '')}>
            Dashboard
          </NavLink>
          <NavLink to={`/m/${slug}/registrations`} className={({ isActive }) => (isActive ? 'underline' : '')}>
            Registrations
          </NavLink>
          <NavLink to={`/m/${slug}/payments`} className={({ isActive }) => (isActive ? 'underline' : '')}>
            Payments
          </NavLink>
          <NavLink to={`/m/${slug}/preferences`} className={({ isActive }) => (isActive ? 'underline' : '')}>
            Preferences
          </NavLink>
          <button onClick={logout} className="underline">
            Sign out
          </button>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}

function RedirectToSignIn({ slug }: { slug: string }) {
  window.location.href = `/m/${slug}/login`;
  return null;
}

export function PortalShell() {
  return (
    <MemberAuthProvider>
      <Inner />
    </MemberAuthProvider>
  );
}
